


















import { RulesCard } from '@/components/rules';
import { AdminsItem } from '@/components/rules/card-items';
import { GeekItemWithJobTitle } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'AdminsCards',
  components: {
    AdminsItem,
    RulesCard: () => Promise.resolve(RulesCard),
  },
  props: {
    data: Array as () => GeekItemWithJobTitle[],
  },
});
